import { render, staticRenderFns } from "./ParentPriceList.vue?vue&type=template&id=73091ec4&"
import script from "./ParentPriceList.vue?vue&type=script&lang=js&"
export * from "./ParentPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports